module.exports = __webpack_public_path__ + "static/img/client_no.9f1398e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client_no.png
// module id = sWt4
// module chunks = 0